// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607221538/js/" + chunkId + "." + {"44":"cfa4b8e0","225":"b78e999b","481":"301b2e5c","486":"501b6466","770":"609bc682"}[chunkId] + ".0.10181110334781085.chunk.js";
};